import React, { useState, useRef, useEffect } from "react";
import {
  Box,
  Button,
  Flex,
  FormControl,
  Input,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalOverlay,
  Text,
} from "@chakra-ui/react";
import { ModalHeader } from "react-bootstrap";
import Login from "../../../services/loginApi";
import { toast } from "react-toastify";

const ModalSendACodeToLogin = ({
  isOpen,
  setIsOpen,
  functionPai,
  setCode,
  type,
  email,
}: any) => {
  const finalRef = useRef(null);

  const onClose = () => {};

  const [codes, setCodes] = useState<string[]>(["", "", "", "", "", ""]);
  const inputsRef = useRef<HTMLInputElement[]>([]);

  const handleChange = (index: number, value: string) => {
    const newCodes = [...codes];
    newCodes[index] = value.replace(/\D/g, "").slice(0, 1); // Limita cada campo a 1 dígito
    setCodes(newCodes);

    // Verifica se o valor inserido é válido e move o foco para o próximo campo se for
    if (value && index < codes.length - 1) {
      inputsRef.current[index + 1].focus();
    }
  };

  const handleKeyDown = (
    index: number,
    event: React.KeyboardEvent<HTMLInputElement>
  ) => {
    // Move para o campo anterior se pressionar Backspace em um campo vazio
    if (event.key === "Backspace" && !codes[index] && index > 0) {
      inputsRef.current[index - 1].focus();
    }
  };

  const handlePaste = (event: React.ClipboardEvent<HTMLInputElement>) => {
    const paste: any = event.clipboardData.getData('text').slice(0, 6); // Limita ao tamanho dos inputs
    const newCodes: any = [...paste].map((char) => char.replace(/\D/g, ""));
    setCodes(newCodes);

    newCodes.forEach((value: any, index: any) => {
      if (inputsRef.current[index]) {
        inputsRef.current[index].value = value;
      }
    });

    // Foca no próximo input após o último preenchido
    const nextIndex = paste.length < 6 ? paste.length : 5;
    if (inputsRef.current[nextIndex]) {
      inputsRef.current[nextIndex].focus();
    }
  };

  const handleSubmit = () => {
    const code = codes.join("");
    console.log("code", code);
    setCode(code);
    functionPai(code);

    setIsOpen(false);
  };

  async function getNewCode() {
    try {
      await Login.GetNewCodeEmail(type, email);
      toast.success("Você receberá um e-mail ou SMS com o código de segurança!");
    } catch (error) {
      toast.error(`Falha ao solicitar código de segurança ${error}`);
      console.log("error", error);
    }
  }

  useEffect(() => {
    if (isOpen === true) {
      setCodes(["", "", "", "", "", ""]); // Redefine os códigos para o estado inicial
      getNewCode();
    }
  }, [isOpen]);

  return (
    <>
      <Modal
        finalFocusRef={finalRef}
        isOpen={isOpen}
        onClose={onClose}
        size={"xl"}
      >
        <ModalOverlay backdropFilter="blur(10px)" />
        <ModalContent>
          <ModalHeader>
            <Flex w={"100%"} justifyContent={"center"} my={2}>
              <Text fontSize={"xl"} fontWeight={"bold"}>
                Digite seu código de verificação
              </Text>
            </Flex>
          </ModalHeader>
          <ModalBody>
            <Flex w={"100%"} justifyContent={"center"}>
              {codes.map((value, index) => (
                <Input
                  key={index}
                  ref={(el) =>
                    (inputsRef.current[index] = el as HTMLInputElement)
                  }
                  type="text"
                  maxLength={1}
                  width="3rem"
                  textAlign="center"
                  value={value}
                  onChange={(e) => handleChange(index, e.target.value)}
                  onKeyDown={(e) => handleKeyDown(index, e)}
                  onPaste={handlePaste}
                  marginRight={2}
                />
              ))}
            </Flex>
          </ModalBody>

          <ModalFooter justifyContent={"space-evenly"}>
            <Button
              mt={4}
              onClick={handleSubmit}
              disabled={codes.some((code) => !code)}
            >
              Confirmar código
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
};

export default ModalSendACodeToLogin;
